var exports = {
  "$0": "xcc377c0b--037075--noImage",
  "ji": "xcc377c0b--037075--noImage-icon",
  "Dd": "xcc377c0b--037075--noImage-text",
};

module.exports = exports;
